export default "__VITE_ASSET__Dzic3Y5Q__"